function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, $hooks, Array, JSON, Object, String) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['mark-as-read'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((alerts.length > 0) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "on": {
              click: $helpers.clickedMarkAlertsAsRead
            },
            "class": Object.assign({}, {
              'mp-sh-menu-mark-read-text-report': $helpers.isReportDisplayContext(),
            }, {
              'mp-sh-menu-mark-read-text': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("Mark all as Read");;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['empty-state'] = function(state, isUpsell) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const displayGif = state === EmptyState.Global;
        const {
          primary,
          secondary
        } = EmptyStateTexts[state];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": Object.assign({}, {
            'mp-sh-empty-state-animated': displayGif
          }, {
            'mp-sh-empty-state': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((displayGif) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("img", {
              "attrs": {
                /*
                 * By un-setting/re-setting the src, the gif will replay from the beginning when the dropdown
                 * is re-opened.
                 */
                src: open ? `/site_media/images/smart_hub/empty_state.gif` : ``,
              },
              "class": {
                'mp-sh-empty-state-image': true
              },
            }));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-sh-empty-state-image': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((isUpsell) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h('div', {
                  props: {
                    innerHTML: '<svg xmlns="http://www.w3.org/2000/svg" width="137" height="134" viewBox="0 0 137 134">  <g fill="none" fill-rule="evenodd" transform="translate(2 2)">    <rect width="117" height="115" x="4" y="4" fill="#EFF2F6" rx="4"/>    <rect width="110" height="34" x="7.5" y="7.5" fill="#FFF" stroke="#ECF0F4" rx="3"/>    <path stroke="#D2DCE4" stroke-linecap="round" stroke-width="2" d="M.40136175 11.2038925L.40136175 21.2073679M99.9390756 16.8058387L99.9390756 21.2073679M5.21770274 16.8058387L5.21770274 21.2073679M29.2994077 16.8058387L29.2994077 21.2073679M10.0340437 5.60194625L10.0340437 21.2073679M14.8503847.400139018L14.8503847 21.2073679M19.6667257 5.60194625L19.6667257 21.2073679M24.4830667 11.2038925L24.4830667 21.2073679M34.1157487 20.0069509L34.1157487 21.2073679M38.1293662 11.2038925L38.1293662 21.2073679M42.9457072 16.8058387L42.9457072 21.2073679M67.0274122 16.8058387L67.0274122 21.2073679M47.7620482 11.2038925L47.7620482 21.2073679M52.5783892.400139018L52.5783892 21.2073679M57.3947302 5.60194625L57.3947302 21.2073679M62.2110712.400139018L62.2110712 21.2073679M71.8437532 11.2038925L71.8437532 21.2073679M75.8573707 5.60194625L75.8573707 21.2073679M80.6737117 5.60194625L80.6737117 21.2073679M85.4900526.400139018L85.4900526 21.2073679M90.3063936 5.60194625L90.3063936 21.2073679M95.1227346 11.2038925L95.1227346 21.2073679" transform="translate(12 14)"/>    <rect width="110" height="34" x="7.5" y="44.5" fill="#FFF" stroke="#ECF0F4" rx="3"/>    <polyline stroke="#D3DDE5" stroke-linecap="round" stroke-width="1.5" points="11 73 17.826 61.955 23.848 68.091 35.894 55 43.121 63.182 48.742 59.091 59.182 69.727 67.212 62.364 76.848 68.091 81.667 61.545 84.879 61.545 87.288 64 101.742 55 109.773 62.364 117 58.273"/>    <rect width="110" height="34" x="7.5" y="81.5" fill="#FFF" stroke="#ECF0F4" rx="3"/>    <g stroke="#D2DCE4" stroke-linecap="round" stroke-width="2" transform="translate(13 88)">      <path d="M.400755565.800278035L3.20604452.800278035M8.01511129.800278035L15.2287115.800278035M20.0377782.800278035L46.4876455.800278035M.400755565 10.4036145L3.20604452 10.4036145M8.01511129 10.4036145L15.2287115 10.4036145M20.0377782 10.4036145L46.4876455 10.4036145M.400755565 20.8072289L3.20604452 20.8072289M8.01511129 20.8072289L15.2287115 20.8072289M20.0377782 20.8072289L46.4876455 20.8072289"/>      <path d="M76.5443128,0.800278035 L79.3496018,0.800278035" transform="matrix(-1 0 0 1 155.493 0)"/>      <path d="M83.757913,0.800278035 L99.38738,0.800278035" transform="matrix(-1 0 0 1 183.145 0)"/>      <path d="M51.2967123,0.800278035 L71.3344905,0.800278035" transform="matrix(-1 0 0 1 122.631 0)"/>      <path d="M76.5443128,10.4036145 L79.3496018,10.4036145" transform="matrix(-1 0 0 1 155.493 0)"/>      <path d="M83.757913,10.4036145 L99.38738,10.4036145" transform="matrix(-1 0 0 1 183.145 0)"/>      <path d="M51.2967123,10.4036145 L71.3344905,10.4036145" transform="matrix(-1 0 0 1 122.631 0)"/>      <path d="M76.5443128,20.8072289 L79.3496018,20.8072289" transform="matrix(-1 0 0 1 155.493 0)"/>      <path d="M83.757913,20.8072289 L99.38738,20.8072289" transform="matrix(-1 0 0 1 183.145 0)"/>      <path d="M51.2967123,20.8072289 L71.3344905,20.8072289" transform="matrix(-1 0 0 1 122.631 0)"/>    </g>    <path stroke="#4BA8FF" stroke-linecap="round" stroke-width="4" d="M125,74.5833941 L125,8 C125,3.581722 121.418278,-2.58798134e-15 117,-1.77635684e-15 L8.259799,-8.8817842e-16 C3.84898845,-7.79256671e-17 0.270367181,3.57007574 0.259821859,7.98087368 L0.00367901531,114.724464 C-0.00688415981,119.14273 3.56626446,122.733004 7.98452983,122.743568 C7.98484338,122.743568 7.98515693,122.743569 7.98547048,122.74357 L120.404089,122.998181 C122.613222,123.003203 124.408149,121.216417 124.413171,119.007284 C124.413178,119.004253 124.413182,119.001222 124.413182,118.998191 L124.413182,91.7839256"/>    <path stroke="#2278E3" stroke-linecap="round" stroke-width="4" d="M125,74.5826939 L125,6.43131217 C125,2.87939654 122.120912,0 118.569378,0 L67.4845256,0 M41,122.856054 C41.1111391,122.856313 120.980861,123.015 121.517954,122.998845 C123.146476,122.949863 124.407537,121.455278 124.411309,119.790475 C124.411314,119.788047 124.411317,119.785618 124.411317,119.783189 L124.411317,91.7830639"/>    <g transform="translate(113 110)">      <circle cx="9.852" cy="9.852" r="8.276" fill="#00805E" fill-rule="nonzero"/>      <circle cx="9.852" cy="9.852" r="9.852" stroke="#FFF" stroke-width="4"/>      <path fill="#FFF" fill-rule="nonzero" d="M9.25914107,10.7786575 C9.28203542,10.7084822 9.27310824,10.6317905 9.23470906,10.5687669 C9.19572693,10.5100468 9.12935818,10.4754823 9.05895624,10.4772356 L7.14143778,10.4772356 C7.11070074,10.4772356 7.09572628,10.4685559 7.09415002,10.4638215 C7.09178564,10.4598762 7.09415002,10.4409387 7.11070074,10.4133215 L11.9742463,4.08030486 C12.1358128,3.8704142 12.2051682,3.89882045 12.1263553,4.15526581 L10.5548255,9.25497759 C10.5284594,9.32351286 10.5342465,9.40028219 10.5705881,9.46407919 C10.6077609,9.52275515 10.6730253,9.55752412 10.7424003,9.55561046 L12.5550976,9.55561046 C12.5866227,9.55561046 12.6031735,9.56586827 12.6079022,9.57454796 C12.612631,9.58243859 12.6118429,9.60374328 12.5960803,9.63372766 L8.00207492,16.4086194 C7.85784726,16.6216663 7.79164441,16.5932601 7.85548288,16.3415491 L9.25914107,10.7786575 L9.25914107,10.7786575 Z"/>    </g>    <g transform="translate(82 40)">      <path stroke="#2278E3" stroke-linecap="round" stroke-width="4.5" d="M28.7072998,28.7072998 L42.1401139,42.1401139"/>      <circle cx="16.347" cy="16.347" r="16.347" stroke="#4BA8FF" stroke-width="5.5"/>      <path stroke="#2278E3" stroke-width="5.5" d="M16.3472124,32.6944248 C25.3755285,32.6944248 32.6944248,25.3755285 32.6944248,16.3472124 C32.6944248,11.8330543 30.8647007,7.74625123 27.9064371,4.78798765"/>      <circle cx="16.347" cy="16.347" r="6.778" fill="#F7C756"/>      <circle cx="16.347" cy="16.347" r="14.752" stroke="#FFF" stroke-width="1.5"/>      <g stroke="#FFF" stroke-linecap="round" transform="translate(14.354 14.354)">        <path d="M0,1.99356249 L2.39227498,0"/>        <path d="M2.39227498,1.99356249 L4.78454996,0" transform="matrix(-1 0 0 1 7.177 0)"/>        <path d="M2.39227498,0.797424994 L2.39227498,4.78454996"/>      </g>    </g>  </g></svg>'
                  }
                }));;
                return __jade_nodes
              }).call(this)) : ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h('div', {
                  props: {
                    innerHTML: '<svg xmlns="http://www.w3.org/2000/svg" width="153" height="143" viewBox="0 0 153 143">  <g fill="none" fill-rule="evenodd">    <rect width="146" height="143" fill="#EFF2F6" rx="4"/>    <rect width="137" height="42" x="4.5" y="4.5" fill="#FFF" stroke="#ECF0F4" rx="3"/>    <path stroke="#D2DCE4" stroke-linecap="round" stroke-width="2" d="M.5 14L.5 26.5M124.5 21L124.5 26.5M6.5 21L6.5 26.5M36.5 21L36.5 26.5M12.5 7L12.5 26.5M18.5.5L18.5 26.5M24.5 7L24.5 26.5M30.5 14L30.5 26.5M42.5 25L42.5 26.5M47.5 14L47.5 26.5M53.5 21L53.5 26.5M83.5 21L83.5 26.5M59.5 14L59.5 26.5M65.5.5L65.5 26.5M71.5 7L71.5 26.5M77.5.5L77.5 26.5M89.5 14L89.5 26.5M94.5 7L94.5 26.5M100.5 7L100.5 26.5M106.5.5L106.5 26.5M112.5 7L112.5 26.5M118.5 14L118.5 26.5" transform="translate(10 12)"/>    <rect width="137" height="42" x="4.5" y="50.5" fill="#FFF" stroke="#ECF0F4" rx="3"/>    <polyline stroke="#D3DDE5" stroke-linecap="round" stroke-width="1.5" points="9 85 17.5 71.5 25 79 40 63 49 73 56 68 69 81 79 72 91 79 97 71 101 71 104 74 122 63 132 72 141 67"/>    <rect width="137" height="42" x="4.5" y="96.5" fill="#FFF" stroke="#ECF0F4" rx="3"/>    <g stroke="#D2DCE4" stroke-linecap="round" stroke-width="2" transform="translate(11 104)">      <path d="M.5 1L4 1M10 1L19 1M25 1L58 1M.5 13L4 13M10 13L19 13M25 13L58 13M.5 26L4 26M10 26L19 26M25 26L58 26"/>      <path d="M95.5,1 L99,1" transform="matrix(-1 0 0 1 194 0)"/>      <path d="M104.5,1 L124,1" transform="matrix(-1 0 0 1 228.5 0)"/>      <path d="M64,1 L89,1" transform="matrix(-1 0 0 1 153 0)"/>      <path d="M95.5,13 L99,13" transform="matrix(-1 0 0 1 194 0)"/>      <path d="M104.5,13 L124,13" transform="matrix(-1 0 0 1 228.5 0)"/>      <path d="M64,13 L89,13" transform="matrix(-1 0 0 1 153 0)"/>      <path d="M95.5,26 L99,26" transform="matrix(-1 0 0 1 194 0)"/>      <path d="M104.5,26 L124,26" transform="matrix(-1 0 0 1 228.5 0)"/>      <path d="M64,26 L89,26" transform="matrix(-1 0 0 1 153 0)"/>    </g>    <g transform="translate(97 45)">      <path stroke="#3881D7" stroke-linecap="round" stroke-width="4.5" d="M36,36 L52.8452384,52.8452384"/>      <circle cx="20.5" cy="20.5" r="20.5" stroke="#4BA8FF" stroke-width="5.5"/>      <path stroke="#3881D7" stroke-width="5.5" d="M20.5,41 C31.8218374,41 41,31.8218374 41,20.5 C41,14.8390813 38.7054593,9.71408131 34.995689,6.00431099"/>      <circle cx="20.5" cy="20.5" r="8.5" fill="#F7C756"/>      <circle cx="20.5" cy="20.5" r="18.5" stroke="#FFF" stroke-width="1.5"/>      <g stroke="#FFF" stroke-linecap="round" transform="translate(18 18)">        <path d="M0,2.5 L3,0"/>        <path d="M3,2.5 L6,0" transform="matrix(-1 0 0 1 9 0)"/>        <path d="M3,1 L3,6"/>      </g>    </g>  </g></svg>'
                  }
                }));;
                return __jade_nodes
              }).call(this)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-sh-empty-state-text-primary': true
            },
          }, [__vjadeSafeCode(primary)]));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-sh-empty-state-text-secondary': true
            },
          }, [__vjadeSafeCode(secondary)]));
          __jade_nodes = __jade_nodes.concat((isUpsell) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("a", {
              "attrs": {
                href: `/pricing/`,
                target: `_blank`
              },
              "class": {
                'mp-sh-empty-state-upgrade-button': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "class": {
                  'mp-button-primary': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Upgrade");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const placement = $attr(`placement`);
    const caretOffset = $component.getCaretOffset(placement);
    const dropdownWidth = $component.dropdownWidth;
    const controller = $helpers.controller();
    const open = controller.isOpen();
    const canSubscribeCustomAlerts = $attr(`enable-custom-alerts`);
    const canSubscribeAutomaticInsights = $attr(`enable-subscribe-alerts`) && $helpers.isReportDisplayContext();
    const {
      EmptyState,
      EmptyStateTexts
    } = $helpers;
    const alerts = $helpers.getReportAlerts();
    return {
      value: (h("div", {
        "class": {
          'mp-sh-menu': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((open) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
            "hook": {
              remove: $hooks.delayedAttrRemove(`open`, false)
            },
            "attrs": {
              open: true,
              'with-caret': controller.getWithCaret(),
              'caret-pos-left': controller.getCaretPosLeft(),
            },
            "style": {
              position: `absolute`,
              left: (placement === `left` || placement === `center`) ? `-${caretOffset}px` : `auto`,
              right: placement === `right` ? `-${caretOffset}px` : `auto`,
              width: open ? `${dropdownWidth}px` : ``,
            },
            "on": {
              change: $helpers.handleDropMenuChange,
            },
            "class": {
              'mp-sh-global-bell': !$helpers.isReportDisplayContext(),
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "style": {
                width: `${dropdownWidth}px`,
              },
              "class": Object.assign({}, {
                'mp-sh-placement-left': placement === `left`,
                'mp-sh-placement-right': placement === `right`,
                'mp-sh-placement-center': placement === `center`,
              }, {
                'mp-sh-menu-caret-container': true
              }),
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-sh-menu-container': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-sh-menu-title': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(($helpers.isReportDisplayContext()) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'mp-sh-menu-title-text': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("Report Alerts");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat(jade_mixins['mark-as-read'].call(this));
                    __jade_nodes = __jade_nodes.concat((canSubscribeAutomaticInsights || canSubscribeCustomAlerts) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'mp-sh-menu-title-icon': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("a", {
                          "attrs": {
                            href: `/settings/account#alert-settings/report/${$attr(`bookmark-id`)}`,
                            target: `_blank`
                          },
                          "on": {
                            click: $helpers.clickedManageAlerts
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-button", {
                            "attrs": {
                              theme: `tertiary`,
                              icon: `settings`
                            },
                          }));
                          __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                            "attrs": {
                              'max-width': `150px`,
                              placement: `left`
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat("Manage Alerts");;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) : undefined);;
                    return __jade_nodes
                  }).call(this)) : ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'mp-sh-menu-title-text': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("All Alerts");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat(jade_mixins['mark-as-read'].call(this));;
                    return __jade_nodes
                  }).call(this)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(($helpers.isReportDisplayContext() && !$helpers.isDashboardDisplayContext()) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'mp-sh-menu-auto-insights': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'mp-sh-menu-auto-insights-text': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("Automatic Insights");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": Object.assign({}, {
                        'mp-sh-menu-auto-insights-toggle-disabled': !$attr(`enable-subscribe-alerts`)
                      }, {
                        'mp-sh-menu-auto-insights-toggle': true
                      }),
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-switch", {
                        "attrs": {
                          disabled: !$attr(`enable-subscribe-alerts`),
                          on: controller.isSubscriptionAlertOn()
                        },
                        "on": {
                          click: $helpers.clickedAutomatedAlertToggle
                        },
                      }));
                      __jade_nodes = __jade_nodes.concat((!$attr(`enable-subscribe-alerts`)) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'mp-sh-menu-auto-insights-toggle-upsell-icon': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                            "attrs": {
                              icon: `lightning-bolt`
                            },
                          }));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)) : ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                          "attrs": {
                            'max-width': `250px`
                          },
                        }, [__vjadeSafeCode($helpers.getSubscriptionToggleTooltipText())]));;
                        return __jade_nodes
                      }).call(this)));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined); /*  dropdown body */
                __jade_nodes = __jade_nodes.concat(($helpers.shouldShowLoadingState()) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'mp-sh-initial-loading': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-spinner"));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : (alerts.length > 0 && (canSubscribeAutomaticInsights || !$helpers.isReportDisplayContext())) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "on": {
                      scroll: $helpers.handleScroll,
                      wheel: $helpers.handleMousewheel,
                    },
                    "hook": {
                      insert: $helpers.fetchAlertsIfNeeded,
                      postpatch: $helpers.fetchAlertsIfNeeded,
                    },
                    "class": {
                      'mp-sh-alerts-container': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat((function() {
                      var $$obj = (alerts);
                      var $$eachNodes;
                      var $$iterated = false;
                      if (Array.isArray($$obj)) {
                        $$eachNodes = $$obj.reduce(function($$eachNodes, alert, index) {
                          $$iterated = true;
                          return $$eachNodes.concat((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat((alert.isDeleted) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "hook": {
                                  insert: vnode => $helpers.insertedDeletedAlert(vnode.elm, alert)
                                },
                                "style": {
                                  height: `${alert.placeholderHeight}px`
                                },
                                "class": {
                                  'mp-sh-deleted-alert': true,
                                  'mp-sh-list-item': true
                                },
                              }));;
                              return __jade_nodes
                            }).call(this)) : ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("mp-smart-hub-notification", {
                                "attrs": {
                                  'project-id': $attr(`project-id`),
                                  'utc-offset': $attr(`utc-offset`),
                                  'display-context': $attr(`display-context`),
                                  'alert': JSON.stringify(alert),
                                  'last-item': (index === alerts.length - 1) || undefined,
                                  'visible': open,
                                  'workspace-id': $attr(`workspace-id`),
                                },
                                "style": {
                                  width: `${dropdownWidth}px`,
                                },
                                "on": {
                                  changedAlert: $helpers.handleChangedAlert,
                                },
                                "class": {
                                  'mp-sh-list-item': true
                                },
                              }));;
                              return __jade_nodes
                            }).call(this)));;
                            return __jade_nodes
                          }).call(this));
                        }, []);
                      } else {
                        $$eachNodes = [];
                        for (var $$objKey in $$obj) {
                          (function() {
                            var index = $$objKey;
                            if ($$obj.hasOwnProperty(index)) {
                              $$iterated = true;
                              var alert = $$obj[index];
                              $$eachNodes = $$eachNodes.concat((function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat((alert.isDeleted) ? ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "hook": {
                                      insert: vnode => $helpers.insertedDeletedAlert(vnode.elm, alert)
                                    },
                                    "style": {
                                      height: `${alert.placeholderHeight}px`
                                    },
                                    "class": {
                                      'mp-sh-deleted-alert': true,
                                      'mp-sh-list-item': true
                                    },
                                  }));;
                                  return __jade_nodes
                                }).call(this)) : ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("mp-smart-hub-notification", {
                                    "attrs": {
                                      'project-id': $attr(`project-id`),
                                      'utc-offset': $attr(`utc-offset`),
                                      'display-context': $attr(`display-context`),
                                      'alert': JSON.stringify(alert),
                                      'last-item': (index === alerts.length - 1) || undefined,
                                      'visible': open,
                                      'workspace-id': $attr(`workspace-id`),
                                    },
                                    "style": {
                                      width: `${dropdownWidth}px`,
                                    },
                                    "on": {
                                      changedAlert: $helpers.handleChangedAlert,
                                    },
                                    "class": {
                                      'mp-sh-list-item': true
                                    },
                                  }));;
                                  return __jade_nodes
                                }).call(this)));;
                                return __jade_nodes
                              }).call(this));
                            }
                          })();
                        }
                      }

                      return $$eachNodes;
                    })());
                    __jade_nodes = __jade_nodes.concat(($helpers.isLoading()) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'mp-sh-pagination-loading': true,
                          'mp-sh-list-item': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-spinner"));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) : undefined);;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat((!$helpers.isReportDisplayContext()) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(jade_mixins['empty-state'].call(this, EmptyState.Global, false));;
                    return __jade_nodes
                  }).call(this)) : (canSubscribeAutomaticInsights) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat((controller.isSubscriptionAlertOn()) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(jade_mixins['empty-state'].call(this, EmptyState.ReportIsSubscribed, false));;
                      return __jade_nodes
                    }).call(this)) : ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(jade_mixins['empty-state'].call(this, EmptyState.ReportNotSubscribed, false));;
                      return __jade_nodes
                    }).call(this)));;
                    return __jade_nodes
                  }).call(this)) : ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(($helpers.eligibleForCustomAlerts()) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((canSubscribeCustomAlerts) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(jade_mixins['empty-state'].call(this, EmptyState.UpsellAutoHasCustomAlerts, true));;
                        return __jade_nodes
                      }).call(this)) : ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(jade_mixins['empty-state'].call(this, EmptyState.UpsellAutoAndCustomAlerts, true));;
                        return __jade_nodes
                      }).call(this)));;
                      return __jade_nodes
                    }).call(this)) : ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(jade_mixins['empty-state'].call(this, EmptyState.UpsellAutoNoCustomAlerts, true));;
                      return __jade_nodes
                    }).call(this)));;
                    return __jade_nodes
                  }).call(this)));;
                  return __jade_nodes
                }).call(this))); /*  bottom button bar */
                __jade_nodes = __jade_nodes.concat(($helpers.eligibleForCustomAlerts()) ? ((function() {
                  var __jade_nodes = []; /*  don't display extra upgrade button for those who don't have either */
                  __jade_nodes = __jade_nodes.concat((canSubscribeCustomAlerts || canSubscribeAutomaticInsights) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'mp-sh-custom-alert-button-container': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      const disabledMessage = $helpers.getCustomAlertsDisabledMessage();
                      __jade_nodes = __jade_nodes.concat((disabledMessage) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                          "attrs": {
                            'max-width': `300px`,
                            placement: `top`
                          },
                        }, [__vjadeSafeCode(disabledMessage)]));;
                        return __jade_nodes
                      }).call(this)) : undefined);
                      const isDisabled = !!disabledMessage && canSubscribeCustomAlerts;
                      __jade_nodes = __jade_nodes.concat(h("mp-button-bar", {
                        "attrs": {
                          disabled: isDisabled
                        },
                        "on": {
                          click: isDisabled ? null : $helpers.clickedCreateCustomAlert
                        },
                        "class": {
                          'mp-button-bar-secondary': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(($helpers.isReportLoading()) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-spinner"));;
                          return __jade_nodes
                        }).call(this)) : ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat((!canSubscribeCustomAlerts) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                              "attrs": {
                                icon: `lightning-bolt`
                              },
                            }));;
                            return __jade_nodes
                          }).call(this)) : undefined);
                          __jade_nodes = __jade_nodes.concat("Create Custom Alert");;
                          return __jade_nodes
                        }).call(this)));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : undefined);;
                  return __jade_nodes
                }).call(this)) : (!$helpers.isReportDisplayContext()) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("a", {
                    "attrs": {
                      href: `/settings/account#alert-settings`
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-button-bar", {
                      "on": {
                        click: $helpers.clickedManageAlerts
                      },
                      "class": {
                        'mp-button-bar-secondary': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("Manage Alerts");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "$hooks" in locals ? locals.$hooks : typeof $hooks !== "undefined" ? $hooks : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;